import {
	SET_DISCUSSIONS,
	SET_DISCUSSION,
	CLEAR_DISCUSSIONS,
	CLEAR_DISCUSSION,
	ADD_DISCUSSION,
	UPDATE_DISCUSSION,
	REMOVE_DISCUSSION,
} from './actionTypes';

export const discussion = (state = {}, action) => {
	switch (action.type) {
		case SET_DISCUSSION:
			return action.payload;
		case UPDATE_DISCUSSION:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_DISCUSSION:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_DISCUSSIONS:
			return action.payload;
		case ADD_DISCUSSION:
			return [...state, action.payload];
		case UPDATE_DISCUSSION:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_DISCUSSION:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_DISCUSSIONS:
			return [];
		default:
			return state;
	}
};
